
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/[useCase]",
      function () {
        return require("private-next-pages/use-cases/[useCase].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/[useCase]"])
      });
    }
  